<template>
  <div :class="isWide ? 'contain-full' : 'container'" class="form-header has-bg-white row-start border-b">
    <div v-show="showBack" class="form-header-item px-4  cursor-hand" @click="onBack()"><i class="iconfont icon-arrowleft" /></div>
    <div v-show="hasLeftbar" class="form-header-item px-4  cursor-hand" @click="onToggleLeftbar">
      <i :class="$store.state.app.showFormLeftbar ? 'iconfont icon-plus-circle-fill has-text-primary' : 'iconfont icon-plus-circle-fill'" style="font-size:24px;" />
    </div>
    <div class="grow" />
    <div :class="{'has-text-primary': activeIndex === 'edit', 'disabled': formUserRole !== 1}" class=" form-header-item px-2  cursor-hand" @click="onItemClick($event, 'edit')">编辑</div>
    <div class="iconfont icon-right has-text-lighter" style="display: inline-block;" />
    <div :class="{'has-text-primary': activeIndex === 'setting', 'disabled': formUserRole !== 1}" class="form-header-item px-2  cursor-hand" @click="onItemClick($event, 'setting')">设置</div>
    <div class="iconfont icon-right has-text-lighter" style="display: inline-block;" />
    <div :class="{'has-text-primary': activeIndex === 'publish', 'disabled': formUserRole !== 1}" class="form-header-item px-2  cursor-hand" @click="onItemClick($event, 'publish')">
      发布<span v-show="isDirty" class="dot" />
    </div>
    <div class="iconfont icon-right has-text-lighter" style="display: inline-block;" />
    <div :class="{'has-text-primary': activeIndex === 'reply'}" class="form-header-item px-2  cursor-hand" @click="onItemClick($event, 'reply-list')">收集</div>
    <div class="grow" />
    <!-- <div class="form-header-item px-2  cursor-hand" title="账号" @click="onAccount"><i class="iconfont icon-user" /> </div> -->
    <div v-show="hasRightbar" class="form-header-item px-4  cursor-hand" @click="onToggleRightbar">
      <i :class="$store.state.app.showFormRightbar ? 'iconfont icon-setting-fill has-text-primary' : 'iconfont icon-setting-fill '" style="font-size:24px;" />
    </div>
  </div>
</template>

<script>
import { isMobileScreen } from '@/utils/index.js'

export default {
  name: 'FormHeader',
  components: {
  },
  props: {
    isWide: {
      type: Boolean,
      default: true
    },
    currentIndex: {
      type: String,
      default: 'edit'
    },
    formUserRole: {
      type: Number,
      default: 2 // 1 属主，2 协管
    }
  },
  data() {
    return {
      activeIndex: this.currentIndex,
      hasLeftbar: false,
      hasRightbar: false,
      isDirty: false,
      timerCheckDirty: null
    }
  },
  computed: {

    showBack() {
      const show = false // isMobBaidu() || isMobWechat()
      return show
    }
  },
  created() {
    console.log('FormHeader created')
    const that = this
    that.timerCheckDirty = setInterval(() => {
      const id = this.$route.params.id
      const formCache = localStorage.getItem(`bd_cache_form_${id}`)
      that.isDirty = !!formCache
    }, 1000)
  },
  mounted() {
    this.hasLeftbar = !!document.querySelector('#form-edit-left')
    this.hasRightbar = !!document.querySelector('#form-edit-right')
  },
  beforeDestroy() {
    clearInterval(this.timerCheckDirty)
  },
  methods: {
    onItemClick(e, index) {
      console.log(index)
      if (e.target.classList.contains('disabled')) {
        return
      }
      this.index = index
      this.$router.push({
        path: `/form/${this.$route.params.id}/${index}`
      })
    },
    onAccount() {
      this.$router.push({
        path: '/'
      })
    },
    onToggleLeftbar() {
      console.log(this.$store.state.app.showFormLeftbar)
      this.$store.dispatch('app/setShowFormLeftbar', !this.$store.state.app.showFormLeftbar)
      if (isMobileScreen() && this.$store.state.app.showFormLeftbar) {
        this.$store.dispatch('app/setShowFormRightbar', false)
      }
    },
    onToggleRightbar() {
      console.log(this.$store.state.app.showFormRightbar)
      this.$store.dispatch('app/setShowFormRightbar', !this.$store.state.app.showFormRightbar)
      if (isMobileScreen() && this.$store.state.app.showFormRightbar) {
        this.$store.dispatch('app/setShowFormLeftbar', false)
      }
    },
    onStorage(event) {
      console.log(event)
    },
    onBack() {
      console.log('onBack')

      window.popstateSignal = false
      this.$router.back()
      setTimeout(() => {
        console.log()
        console.log('onBack timeout:' + window.popstateSignal)
        if (!window.popstateSignal) {
          window.location.href = 'https://bahuyun.com/bd-home'
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
// a.active {
//   color: #06F
// }
.form-header {
  height: 50px;
  line-height: 50px;
  color:#606266;
  .form-header-item {
    display: inline-block;
    position: relative;
  }
  .dot {
    width: 8px;
    height: 8px;
    display: inline-block;
    background: #f56c6c;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 0px;
  }
}
</style>
